import { render, staticRenderFns } from "./StoreDecorate.vue?vue&type=template&id=18dfb49c&scoped=true&"
import script from "./StoreDecorate.vue?vue&type=script&lang=js&"
export * from "./StoreDecorate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfb49c",
  null
  
)

export default component.exports